import styles from './Problem.module.css';

export default function Problem() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <span className={styles.label}>The problem</span>
        <h2 className={styles.heading}>You're stuck choosing between speed and quality.</h2>

        <div className={styles.traps}>
          <div className={styles.trap}>
            <span className={styles.trapTag}>Go fast</span>
            <p className={styles.trapText}>
              Dump accounts into a stale database and pitch people who quit six months ago.
            </p>
          </div>
          <div className={styles.divider}>or</div>
          <div className={styles.trap}>
            <span className={styles.trapTag}>Go careful</span>
            <p className={styles.trapText}>
              Burn hours cross-referencing profiles, testing emails, and duct-taping APIs
              into your own enrichment waterfall.
            </p>
          </div>
        </div>

        <p className={styles.resolution}>
          RepBuddy was built out of pure personal frustration to fix that fragmentation.
        </p>
      </div>
    </section>
  );
}
